<sd-6-17-1-dialog
  #dialog
  [headline]="headline | transloco"
  (afterHide)="onAfterHide()">
  <div class="save-filter-template-dialog">
    <div class="input-with-space">
      <sd-6-17-1-input
        #nameInput
        lang="de"
        size="md"
        [placeholder]="'Vorlage '"
        [value]="nameValue()"
        (input)="onNameChanged($event)"></sd-6-17-1-input>
    </div>

    <div class="dialog-actions">
      <sd-6-17-1-button
        variant="tertiary"
        type="button"
        (click)="cancel()">
        {{ cancelLabel | transloco }}
      </sd-6-17-1-button>
      <sd-6-17-1-button
        wctLoadingIndicator
        [apiCallAdditionalLoading]="saving()"
        variant="primary"
        type="button"
        [disabled]="!canSave"
        (click)="confirm()">
        {{ confirmLabel | transloco }}
      </sd-6-17-1-button>
    </div>
  </div>
</sd-6-17-1-dialog>

